package com.macrofocus.eflux.ui

import com.macrofocus.common.properties.MutableProperty
import com.macrofocus.eflux.network.LinkField
import i18next.invoke
import i18next.useTranslation
import mui.material.*
import mui.system.sx
import org.mkui.react.useProperty
import react.FC
import react.Props
import react.ReactNode
import react.create
import react.dom.events.ChangeEvent
import web.cssom.px
import web.dom.ElementId
import web.html.HTMLInputElement

external interface LinkSingleSelectProps : Props {
    var labelId : String
    var tkey : String
    var field: MutableProperty<LinkField<*>?>
    var fields : Array<LinkField<*>>
    var disabled : Boolean?
}

val LinkSingleSelect = FC<LinkSingleSelectProps> { props ->
    val (t, _) = useTranslation()

    val (getField, setField) = useProperty(props.field)

    FieldControl {
        InputLabel {
//            id = "appMenu.configuration.links.movement-label"
//                attrs.classes(classes.inputLabel)
//            +t("appMenu.configuration.links.movement")
            id = ElementId(props.labelId)
////                attrs.classes = classes.inputLabel
            +t(props.tkey)
        }
        Select {
            sx {
                marginBottom = 10.px
            }


//                attrs.classes = classes.select
//            labelId = "appMenu.configuration.links.movement-label"
//            id = "appMenu.configuration.links.movement"
            variant = SelectVariant.outlined
            labelId = props.labelId
            label = ReactNode(t(props.tkey))
            id = ElementId(props.tkey)
            margin = InputBaseMargin.dense
            displayEmpty = true
            value = (getField ?: "").unsafeCast<Nothing?>()
            if(props.disabled != null) {
                disabled = props.disabled
            }
            renderValue = {
                ListItemText.create() {
                    if(it is Array<*>) {
                        primary = ReactNode(it.joinToString())
                    } else {
                        if(it != null) {
                            primary = ReactNode(it.toString())
                        } else {
                            primary = ReactNode("")
                        }
                    }
                }
            }
            val onChangeFunction: (ChangeEvent<HTMLInputElement,*>, ReactNode) -> Unit = { it, node ->
                val value = it.asDynamic().target.value
                val field: LinkField<*>? = if (value != "" && value is LinkField<*>) value else null
                setField(field)
            }
            onChange = onChangeFunction

            MenuItem {
                dense = true
                value = ""
                ListItemText { +"None" }
            }
            props.fields.forEach {
                MenuItem {
                    dense = true
                    value = it.unsafeCast<Nothing?>()
                    val icon = it.icon
                    if (icon != null) {
                        ListItemIcon { Icon { +icon } }
                    }
                    ListItemText { +it.toString() }
                }
            }
        }
    }
}
